interface PortalConfig {
  bg: string;
  fg: string;
  label: string;
}

const PORTAL_MAP: Record<string, PortalConfig> = {
  amazon: { bg: "#FFF3D6", fg: "#A1660B", label: "Amazon" },
  ebay: { bg: "#E6F3FB", fg: "#0288D1", label: "eBay" },
  shopify: { bg: "#E6F7F0", fg: "#10B981", label: "Webshop" },
  kaufland: { bg: "#FFECEA", fg: "#C53D3D", label: "Kaufland" },
  metro: { bg: "#EAF2FD", fg: "#3061B0", label: "Metro" },
  dreamrobot: { bg: "#F4F6F8", fg: "#374151", label: "DreamRobot" },
  manual: { bg: "#F4F6F8", fg: "#6B7280", label: "Manuell" },
};

/** Rohwerte wie "Amazon-FBA", "shopify_app", "metro_markets_app" auf den Badge-Schluessel
 * abbilden — dieselben Regeln wie normalizePlatform im Backend (dashboard/platform-map.ts). */
function portalKey(portal: string | null | undefined): string {
  const v = (portal ?? "").trim().toLowerCase();
  if (v in PORTAL_MAP) return v;
  if (v.startsWith("amazon")) return "amazon";
  if (v.startsWith("ebay")) return "ebay";
  if (v.startsWith("shopify")) return "shopify";
  if (v.includes("metro")) return "metro";
  if (v.includes("kaufland")) return "kaufland";
  return v;
}

const FALLBACK = PORTAL_MAP.manual!;

/**
 * Sichtbare Beschriftung eines Portals — dieselbe Quelle, die das Badge rendert.
 * Damit koennen sichtbarer Text und Screenreader-Text nicht auseinanderlaufen
 * (z.B. sichtbar „Webshop", vorgelesen „Shopify"). Unbekannte Schluessel behalten
 * ihren Rohwert, statt auf „Manuell" zu fallen: fuer eine Vorlese-Beschriftung
 * ist der echte Portalname informativer als das Fallback-Label.
 */
export function portalLabel(portal: string | null | undefined): string {
  const key = portalKey(portal);
  return PORTAL_MAP[key]?.label ?? (portal || FALLBACK.label);
}

export function PortalBadge({ portal }: { portal: string | null | undefined }) {
  const key = portalKey(portal);
  const cfg = PORTAL_MAP[key] ?? FALLBACK;
  return (
    <span
      className="inline-block px-1.5 py-0.5 rounded font-mono text-[11px] font-semibold"
      style={{ background: cfg.bg, color: cfg.fg }}
    >
      {cfg.label}
    </span>
  );
}
